module.exports = __webpack_public_path__ + "static/media/bleeding.9414acc8.jpeg";